module.exports = __webpack_public_path__ + "img/Github.aa0b295c.png";